import axios from 'axios';
import { API_ENDPOINT } from '../authApi/api'; 


export const registerUser = async (formData) => {
  try {
    const response = await axios.post(API_ENDPOINT.ADMIN_REGISTER, formData, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    console.error("Error in registerUser:", error.response?.data || error.message);
    throw error;
  }
};

export const loginUser = async (formData) => {
  try {
    const response = await axios.post(API_ENDPOINT.ADMIN_LOGIN, formData, {
      headers: { 'Content-Type': 'application/json' },
    });
    const token = response.data.token;
    if (token) {
      localStorage.setItem('token', token);
    }
    return response.data;
  } catch (error) {
    console.error("Error in loginUser:", error.response?.data || error.message);
    throw error;
  }
};




// Fetch all countries
export const getCountries = async () => {
  try {
    const response = await axios.get(API_ENDPOINT.GET_COUNTRIES);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch countries:", error);
    throw error?.response?.data || { message: "Error fetching countries" };
  }
};

// Fetch states by country ID
export const getStatesByCountry = async (countryId) => {
  try {
    const url = API_ENDPOINT.GET_STATES_BY_COUNTRY(countryId);
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch states for country ${countryId}:`, error);
    throw error?.response?.data || { message: "Error fetching states" };
  }
};

// Fetch cities by state ID
export const getCitiesByState = async (stateId) => {
  try {
    const url = API_ENDPOINT.GET_CITIES_BY_STATE(stateId);
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch cities for state ${stateId}:`, error);
    throw error?.response?.data || { message: "Error fetching cities" };
  }
};


export const createCountry = async (data) => {
  try {
    const response = await axios.post(API_ENDPOINT.CREATE_COUNTRY, data, { headers });
    return response.data;
  } catch (error) {
    console.error("Failed to create country:", error);
    throw error?.response?.data || { message: "Error creating country" };
  }
};

export const updateCountry = async (id, data) => {
  try {
    const url = API_ENDPOINT.UPDATE_COUNTRY(id);
    const response = await axios.patch(url, data, { headers });
    return response.data;
  } catch (error) {
    console.error(`Failed to update country ${id}:`, error);
    throw error?.response?.data || { message: "Error updating country" };
  }
};

export const deleteCountry = async (id) => {
  try {
    const url = API_ENDPOINT.DELETE_COUNTRY(id);
    const response = await axios.delete(url, { headers });
    return response.data;
  } catch (error) {
    console.error(`Failed to delete country ${id}:`, error);
    throw error?.response?.data || { message: "Error deleting country" };
  }
};

// ==========================================
// STATE CRUD
// ==========================================

export const createState = async (data) => {
  try {
    const response = await axios.post(API_ENDPOINT.CREATE_STATE, data, { headers });
    return response.data;
  } catch (error) {
    console.error("Failed to create state:", error);
    throw error?.response?.data || { message: "Error creating state" };
  }
};

export const updateState = async (id, data) => {
  try {
    const url = API_ENDPOINT.UPDATE_STATE(id);
    const response = await axios.patch(url, data, { headers });
    return response.data;
  } catch (error) {
    console.error(`Failed to update state ${id}:`, error);
    throw error?.response?.data || { message: "Error updating state" };
  }
};

export const deleteState = async (id) => {
  try {
    const url = API_ENDPOINT.DELETE_STATE(id);
    const response = await axios.delete(url, { headers });
    return response.data;
  } catch (error) {
    console.error(`Failed to delete state ${id}:`, error);
    throw error?.response?.data || { message: "Error deleting state" };
  }
};

// ==========================================
// CITY CRUD
// ==========================================

export const createCity = async (data) => {
  try {
    const response = await axios.post(API_ENDPOINT.CREATE_CITY, data, { headers });
    return response.data;
  } catch (error) {
    console.error("Failed to create city:", error);
    throw error?.response?.data || { message: "Error creating city" };
  }
};

export const updateCity = async (id, data) => {
  try {
    const url = API_ENDPOINT.UPDATE_CITY(id);
    const response = await axios.patch(url, data, { headers });
    return response.data;
  } catch (error) {
    console.error(`Failed to update city ${id}:`, error);
    throw error?.response?.data || { message: "Error updating city" };
  }
};

export const deleteCity = async (id) => {
  try {
    const url = API_ENDPOINT.DELETE_CITY(id);
    const response = await axios.delete(url, { headers });
    return response.data;
  } catch (error) {
    console.error(`Failed to delete city ${id}:`, error);
    throw error?.response?.data || { message: "Error deleting city" };
  }
};


export const bulkDeleteCities = async (cityIds) => {
  try {
    const response = await axios.delete(API_ENDPOINT.ALL_DELETE_CITY, {
      headers,
      data: { cityIds }
    });
    return response.data;
  } catch (error) {
    console.error("Bulk delete failed:", error);
    throw error?.response?.data || { message: "Bulk delete error" };
  }
};



const token = localStorage.getItem('token');
const headers = {
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
};  


// Get all categories
export const getCategories = async () => {
  const res = await axios.get(`${API_ENDPOINT.GET_CATEGORIES}`, );
  return res.data;
};

// Get subcategories by category ID
export const getSubcategories = async (categoryId) => {
  const res = await axios.get(`${API_ENDPOINT.GET_SUBCATEGORIES(categoryId)}`,);
  return res.data;
};


